export const updateObject = (oldObj, newObj) => {
  return {
    ...oldObj,
    ...newObj,
  };
};
